import { TextButton } from '@artprov/design-system'
import { useNavigate } from 'react-router-dom'

export default function BackButton() {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1) 
  }

  return (
    <TextButton 
      IconLeft={'chevron_left'} 
      onClick={handleGoBack} 
      className="mb-2"
      size="extra-small"
    >
    Volver 
    </TextButton>
  )
}